export const GET_LIST_KIEMTRANOXAU = "GET_LIST_KIEMTRANOXAU";
export const GET_LIST_KIEMTRANOXAU_SUCCESS = "GET_LIST_KIEMTRANOXAU_SUCCESS";
export const GET_LIST_KIEMTRANOXAU_FAILURE = "GET_LIST_KIEMTRANOXAU_FAILURE";
